import {
  RECEIVE_USERINFO
} from '../actions/login'


const login = (state = {auths:{}}  , action) => {
  switch (action.type) {
      case RECEIVE_USERINFO:
        return {...state, user:action.data,userId:action.data.userId,userName:action.data.userName,auths:action.data.auths,tokenId:action.data.tokenId,menus:action.data.menus}
    default:
      return state
  }
}

export default login


// WEBPACK FOOTER //
// ./reducers/login.js